import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';

import {useLogoutStore} from '../../../store/slices/logoutStore';

export const HideButtonWhenLogout = (props) => {
  const actionLogout = useLogoutStore((state) => state.actionLogout);
  const [showButtons, setShowButtons] = useState(true);

  useEffect(() => {
    if (actionLogout) {
      setShowButtons(false);
    }
  }, [actionLogout]);

  return showButtons && props.children;
};

HideButtonWhenLogout.propTypes = {
  children: PropTypes.element
};
